import { Component, OnDestroy, OnInit} from '@angular/core';
import { ReturnObject } from '../../models/returnObject';
import { SetAdminItem } from '../../models/setadminitem';
import { SysadminService } from '../../services/sysadmin/sysadmin.service';
import { Subscription } from 'rxjs';
import { InternalMsgService } from '../../services/internal.msg.service';
import { AccountService } from '../../services/account.service';
import { AccountItem } from '../../models/accountitem';
import { StatusMessagesService } from '../../services/statusmessage.service';

@Component({
    selector: 'sysadmin-set-admin',
    templateUrl: './sysadmin-set-admin.component.html',
    styleUrls: ['./sysadmin-set-admin.component.css']
})
export class SysadminSetAdminComponent implements OnInit, OnDestroy {
    searchString: string = '';
    loggedAccount: AccountItem = new AccountItem();
    employees: SetAdminItem[] = [];
    filteredEmployees: SetAdminItem[] = [];
    msgSubscr: Subscription = new Subscription();
    curPage: number = 0;
    totalPages: number = 0;
    slicedRows: SetAdminItem[] = [];
    spinnerMessage: string = '';

    constructor(private sysadminService: SysadminService,
        private msgService: InternalMsgService,
        private accountService: AccountService,
        private statusMessagesService: StatusMessagesService) { 
    }

    ngOnInit() 
    {
        this.GetEmps();
        window.addEventListener("tdsFilter", (event: any) => {
            this.searchString = event['detail']['query'];
            this.curPage = 0;
            this.totalPages = 0;
            this.filteredEmployees = [];
            this.setFilter();
          });
          
         window.addEventListener("tdsPagination", (event: any) => {
            this.curPage = Number( event['detail']['paginationValue'] ) - 1;
            this.setSlicedRows();

        });
        
        this.msgSubscr = this.msgService.loggedInAccountSet$.subscribe( 
            account => {
                this.loggedAccount = account;
        } );     
        this.accountService.fetchAccount();
    }

    ngOnDestroy() {
        this.msgSubscr.unsubscribe();
    }


    GetEmps(): void {
        this.msgService.ontoggleSpinnerSet(true);
        this.sysadminService.getEmps()
            .subscribe( { 
                next: (data: ReturnObject<SetAdminItem[]>) => {
                    if (data.isFailure) {
                        this.statusMessagesService.showToasterError('Error', "Failed to load employees.");
                        return;
                    }
                    this.employees = data.value;
                    this.curPage = 0;
                    this.filteredEmployees = this.employees;
                    this.totalPages = Math.ceil( this.filteredEmployees.length / 10 );
        
                    this.setSlicedRows();
                },
                error: (err) => {         
                    this.statusMessagesService.showHttpError(err);
                },
                complete: () => {         
                    this.msgService.ontoggleSpinnerSet(false);
                }
            }
        );
    }

    changeAdminStatus(emp: SetAdminItem) : void {
        this.msgService.ontoggleSpinnerSet(true);
        this.sysadminService.changeAdminStatus(emp)
            .subscribe( { 
                next: (data: ReturnObject<string>) => {
                    if (data.isFailure) {
                        this.statusMessagesService.showToasterError('Error', data.failureMessage);
                        return;
                    }
                    this.GetEmps();
                    this.statusMessagesService.showToasterSuccess('Changed', data.value);
                },
                error: (err) => {         
                    this.statusMessagesService.showHttpError(err);
                },
                complete: () => {         
                    this.msgService.ontoggleSpinnerSet(false);
                }
            }
        );
    }

    changeReportingStatus(emp: SetAdminItem) : void {
        this.msgService.ontoggleSpinnerSet(true);
        this.sysadminService.changeReportingStatus(emp)
            .subscribe( { 
                next: (data: ReturnObject<string>) => {
                    if (data.isFailure) {
                        this.statusMessagesService.showToasterError('Error', data.failureMessage);
                        return;
                    }
                    this.GetEmps();
                    this.statusMessagesService.showToasterSuccess('Changed', data.value);
                },
                error: (err) => {         
                    this.statusMessagesService.showHttpError(err);
                },
                complete: () => {         
                    this.msgService.ontoggleSpinnerSet(false);
                }
            }
        );
    }

   
    setSlicedRows(): void {
        this.slicedRows = this.filteredEmployees.slice(this.curPage * 10, (this.curPage * 10) + 10)
    }

    setFilter(): void {
        if (this.searchString.trim() == '' )
            this.filteredEmployees = this.employees;

        const str = this.searchString.toLowerCase();

        this.filteredEmployees = this.employees.filter( x => x.email.toLowerCase().includes(str) || x.empName?.toLowerCase().includes(str) || x.email?.toLowerCase().includes(str));
        this.totalPages = Math.ceil( this.filteredEmployees.length / 10 );
        this.setSlicedRows();
    }
}
